import cn from 'classnames';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import Modal from '../../../../../components/mazraeKit/modal';

interface ISuccessRegisterModalProps {
  isSuccessModal: boolean;
  title?: string;
  desc?: string;
  setIsSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  removeOnClick?: () => void;
  rejectedOnClick?: () => void;
  understandOnClick?: () => void;
  editOnClick?: () => void;
  successBtnTitle?: string;
  isEdit: boolean;
  onSuccessBtnClick?: () => void;
}

const StoreAndLabResultModal = ({
  setIsSuccessModal,
  title,
  desc,
  isSuccessModal,
  removeOnClick,
  editOnClick,
  rejectedOnClick,
  understandOnClick,
  onSuccessBtnClick,
  successBtnTitle,
  isEdit,
}: ISuccessRegisterModalProps) => {
  return (
    <Modal isOpen={isSuccessModal} setIsOpen={setIsSuccessModal}>
      <div className="w-[320px] flex flex-col p-3 gap-3">
        <div className="flex items-center justify-between">
          <div className="flex w-[90%] justify-center">
            <SpanIcon
              className={cn(
                'text-xxxl',
                {'icon-nameremove-circle text-red-500': isEdit},
                {'icon-nameCheck-circle text-farm-shop-500': !isEdit},
              )}
            />
          </div>
          <button onClick={removeOnClick}>
            <SpanIcon className="icon-nameClose-remove text-xl text-gray-700 w-[10%]" />
          </button>
        </div>
        <h5 className="w-full text-gray-950 flex justify-center text-xl font-Medium">
          {title}
        </h5>
        <p className="w-full p-0 m-0 text-gray-700 text-md font-Regular">
          {desc}
        </p>
        {isEdit ? (
          <div className="flex gap-2">
            <button
              className="bg-farm-shop-500 text-white rounded h-10 w-full mt-1 text-regular text-sm"
              onClick={editOnClick}
            >
              رفع نواقص
            </button>
            <button
              className="border-farm-shop-500 bg-white text-farm-shop-500 border-[1px] rounded h-10 w-full mt-1 text-regular text-sm"
              onClick={rejectedOnClick}
            >
              انصراف
            </button>
          </div>
        ) : (
          <button
            className="bg-farm-shop-500 text-white rounded h-10 w-full mt-1 text-regular text-sm"
            onClick={onSuccessBtnClick}
          >
            {successBtnTitle}
          </button>
        )}
      </div>
    </Modal>
  );
};

export default StoreAndLabResultModal;
